export default function removeDeviceWires(state, action) {
  const { id, endType } = action
  const wires = { ...state.entities.wires.byId }
  const connectedWireIds = Object.values(wires).filter(wire => wire.start.type === endType && wire.start.id === id || wire.end.type === endType && wire.end.id === id).map(wire => wire.id)
  connectedWireIds.forEach(wireId => delete wires[wireId])

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      wires: {
        byId: wires,
        allIds: state.entities.wires.allIds.filter(currentId => !connectedWireIds.includes(currentId))
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/removeDeviceWires.js